import {
    AnnouncementUserAction,
    AnnouncementUserActionTypes,
    AnnouncementUserState,
    IAnnouncementItem
} from "./types";

const initialState: AnnouncementUserState = {
    announcements: [],
    announcementsCount: 0,
    projects: [],
    projectsCount: 0,
    announcementPage: {
        title: "",
        description: "",
        keyWords: "",
        isFormNeeded: false,
        contents: []
    }
}

export const announcementUserReducer = (state = initialState, action: AnnouncementUserAction): AnnouncementUserState => {
    switch (action.type) {
        case AnnouncementUserActionTypes.GET_NOVELTIES:
            return {
                ...state,
                announcementsCount: action.payload.count,
                announcements: action.payload.values,
            }
        case AnnouncementUserActionTypes.GET_SIMILAR:
            return {
                ...state,
                announcements: action.payload,
            }
        case AnnouncementUserActionTypes.ADD_NOVELTIES:
            let tempArr: Array<IAnnouncementItem> = [];
            if (state.announcements.length !== 0)
                tempArr = tempArr.concat(state.announcements, action.payload.values);
            else
                tempArr = action.payload.values;
            return {
                ...state,
                announcementsCount: action.payload.count,
                announcements: tempArr,
            }
        case AnnouncementUserActionTypes.GET_ANNOUNCEMENT_BY_URLSLUG:
            return {
                ...state,
                announcementPage: action.payload,
            }
        case AnnouncementUserActionTypes.GET_HEADER_PROJECTS:
            return {
                ...state,
                projectsCount: action.payload.count,
                projects: action.payload.values,
            }
        default:
            return state;
    }
}